/**
 * Admin PWA multi-client reload BroadcastChannel (NP-04).
 * Isolated from `import.meta.env` / Workbox so Jest can import live listeners.
 */

import { runAdminPwaPeerTabReload } from './adminPwaRefreshEscalation.js';

export const ADMIN_PWA_RELOAD_CHANNEL = 'rpapp-admin-pwa-reload';

export function broadcastAdminPwaReload(): void {
  try {
    const channel = new BroadcastChannel(ADMIN_PWA_RELOAD_CHANNEL);
    channel.postMessage({ type: 'reload' });
    channel.close();
  } catch {
    // BroadcastChannel may be unavailable
  }
  void runAdminPwaPeerTabReload();
}

export function listenAdminPwaReloadChannel(): () => void {
  if (typeof BroadcastChannel === 'undefined') {
    return () => undefined;
  }
  const channel = new BroadcastChannel(ADMIN_PWA_RELOAD_CHANNEL);
  const onMessage = (event: MessageEvent): void => {
    if (event.data?.type === 'reload') {
      void runAdminPwaPeerTabReload();
    }
  };
  channel.addEventListener('message', onMessage);
  return () => {
    channel.removeEventListener('message', onMessage);
    channel.close();
  };
}
